// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"52f77fbf","239":"86244078","453":"564ac860","455":"6f618bb4"}[chunkId] + ".chunk.js";
};